// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_6eb00b8e53--spinner--26-7j","circle-spin":"_6eb00b8e53--circle-spin--2RZC8"};